import React, { FunctionComponent, ReactNode } from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from '../../../../../hooks/useTranslation';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      marginBottom: '15px',
      paddingLeft: '10px',
      '& .outage-report-message p': {
        margin: '0 !important',
      },
    },
  }),
);

interface Props {
  isOutageReported: boolean | undefined | null;
  statusMessage?: ReactNode | string;
}

const OutageStatus: FunctionComponent<Props> = ({
  isOutageReported,
  statusMessage,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <div className={classes.root}>
      {isOutageReported ? (
        <Typography variant={'subtitle2'} data-testid="outage-status-reported">
          {t('OUTAGE_REPORTED_SUCCESS')}
        </Typography>
      ) : (
        <>
          <Typography
            variant={'subtitle1'}
            data-testid="outage-status-not-reported"
            className="outage-report-message"
          >
            {statusMessage}
          </Typography>
        </>
      )}
    </div>
  );
};

export default OutageStatus;
